import script from "./GreetingPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./GreetingPage.vue?vue&type=script&lang=ts&setup=true"

const cssModules = script.__cssModules = {}
import style0 from "./GreetingPage.vue?vue&type=style&index=0&id=32bc4f30&lang=scss&module=true"
cssModules["$style"] = style0

export default script